import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../actions/translator";
import supportedLanguages from "../data/supportedLanguages";
import { fromPlaceholder, toPlaceholder, geordie } from "../copy/";

import TranslationTextInput from "../components/TranslationTextInput";
import Loader from "../components/Loader";
import LanguageMenu from "../components/LanguageMenu";
import CallOut from "../components/CallOut";

import SlideIn from "../animations/SlideIn";
import { LanguageSelection, Label } from "../components/LanguageSelection";

class TranslatorContainer extends Component {
  handleTextInput(text) {
    this.props.translateText({
      ...this.props.translator.settings,
      text: text
    });
  }

  render() {
    const placeholderLabel = this.props.translator.settings.reversed
      ? geordie
      : this.props.translator.settings.label;
    return (
      <div>
        <LanguageMenu
          label={this.props.translator.settings.label}
          reversed={this.props.translator.settings.reversed}
          toggleLanguageMenu={this.props.toggleLanguageMenu.bind(this)}
          swapSelectedLanguages={this.props.swapSelectedLanguages.bind(this)}
        />
        <SlideIn>
          {this.props.translator.showLanguageMenu ? (
            <LanguageSelection>
              {supportedLanguages.map((lang, i) => {
                return (
                  <Label
                    selected={lang.code === this.props.translator.settings.code}
                    key={i}
                    onClick={() => this.props.selectLanguage(lang)}
                  >
                    {lang.name}
                  </Label>
                );
              })}
            </LanguageSelection>
          ) : null}
        </SlideIn>
        <TranslationTextInput
          loading={this.props.translator.loadingTranslation}
          nodeRef="input"
          blur={this.props.translator.showLanguageMenu}
          primary={true}
          lang={this.props.translator.settings.code}
          placeholder={fromPlaceholder(placeholderLabel)}
          action={this.handleTextInput.bind(this)}
        />
        <TranslationTextInput
          blur={this.props.translator.showLanguageMenu}
          placeholder={toPlaceholder}
          disabled={true}
          readOnly={true}
          nodeRef="translation"
          value={this.props.translator.translatedText}
        >
          <Loader
            vPos={true}
            loading={this.props.translator.loadingTranslation}
          />
        </TranslationTextInput>
        <CallOut blur={this.props.translator.showLanguageMenu} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translator: state.translator
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(
  TranslatorContainer
);



// WEBPACK FOOTER //
// ./src/containers/TranslatorContainer.js